<template>
  <div class="index">
    <div class="menu-bg">
      <img src="../assets/images/index/logo.png" alt="" class="logo" />
      <img
        src="../assets/images/index/liebiao.png"
        alt=""
        class="menu"
        v-on:click="menuAction"
      />
      <!-- <span v-on:click="menuAction"></span> -->
    </div>
    <div class="menu-hide-bg" v-show="menuShow2">
      <span v-on:click="menuAction"></span>
    </div>
    <transition name="fade">
      <div class="menuCSSHide" v-show="menuShow">
        <ul>
          <li v-for="(item, index) in menutitles" :key="index">
            <a v-on:click="menuTitleAction(index)">{{ item }}</a>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "menus",
  data() {
    return {
      menuShow: false,
      menuShow2: false,
      menutitles: [
        "首页",
        "关于快美",
        "快美红人",
        "直播电商",
        "快新闻",
        "加入快美",
      ],
    };
  },
  methods: {
    menuAction: function () {
      if (this.menuShow) {
        this.menuShow = false;
        this.menuShow2 = false;
      } else {
        this.menuShow = true;
        this.menuShow2 = true;
      }
    },
    menuTitleAction: function (index) {
      console.log(index, "=======");
      this.menuShow = false;
      this.menuShow2 = false;
      switch (index) {
        case 0:
          this.$router.push("/index");
          break;
        case 1:
          this.$router.push("/about_km");
          break;
        case 2:
          this.$router.push("/hongRen");
          break;
        case 3:
          this.$router.push("/show_km");
          break;
        case 4:
          this.$router.push("/news_km");
          break;
        case 5:
          this.$router.push("/join_km");
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 99999;
  // filter: grayscale(100%);
}
.menu-bg {
  display: flex;
  justify-content: space-between;
  .logo {
  width: 50%;
  height:15%;
    // width: 4rem;
    // height: .9rem;
  }
  .menu {
    width: 0.55rem;
    height: 0.55rem;
    padding: 0.15rem;
  }
}
.menuCSSHide {
  width: 50%;
  height: 100%;
  background-color: #000;
  color: #fff;
  position: fixed;
  top: 0;
  z-index: 1002;
  right: 0;

  ul {
    margin-top: 1rem;
    li {
      width: 100%;
      border-bottom: 1px solid #666;
      height: 1rem;
      line-height: 1rem;
      text-align: center;
      font-size: 0.3rem;
      a {
        color: #fff;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: left -70%;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  left: 0;
}
.menu-hide-bg {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  span {
    width: 0.4rem;
    height: 0.4rem;
    background: url(../assets/images/closebtn.png) no-repeat;
    background-size: cover;
    position: absolute;
    right: 4.5rem;
    top: 50%;
    // margin-top: 0.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menu.vue